<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="$t('nav.api')" :breadCrumbFirstLink="'/'" :title="$t('nav.api')">
    </ToolsPanel>
    <ContentContainer>
      <div class="static">
        <div class="static__item">
          {{ $t("static.sendLeadTo") }} <b>{{ getUrl() }}/v1/leads/create</b>
        </div>
        <div class="static__item">
          {{ $t("static.sendLeadWithName") }} <b>{{ getUrl() }}/v1/leads/create-with-name</b>
        </div>
      </div>
    </ContentContainer>
  </Main>
</template>

<script>
import Main from "~/templates/Main.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";

export default {
  name: "Static",
  metaInfo() {
    return {
      title: this.$t("nav.api"),
    };
  },
  data() {
    return {};
  },
  components: {
    Main,
    ToolsPanel,
    ContentContainer,
  },
  mounted() {},

  methods: {
    getUrl() {
      return process.env.VUE_APP_API;
    },
  },
};
</script>

<style lang="scss" scoped>
.static {
  &__item {
    font-size: 18px;
    padding-bottom: 10px;
  }
}
</style>
